import React, { useEffect, useState } from 'react';
import data from '../data/data.json'; // Импорт JSON-файла

export const Why = () => {
  const [whyData, setWhyData] = useState([]);

  useEffect(() => {
    if (data && data.Why) {
      setWhyData(data.Why); // Загружаем данные из JSON
    }
  }, []);

  return (
    <div className="why text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Почему именно мы?</h2>
          <p>Качество, соблюдение сроков, круглосуточная работа и гарантии на высоком уровне.</p>
        </div>
        <div className="row">
          {whyData.length > 0
            ? whyData.map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-xs-6 col-md-3">
                  <i className={d.icon}></i>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : "Загрузка..."}
        </div>
      </div>
    </div>
  );
};
